import { css } from 'lit';

export const labelStyling = () => css`
  color: var(--spectrum-gray-700);
  font: normal normal normal 12px/18px Adobe Clean;
  letter-spacing: 0px;
`;
